import { render, staticRenderFns } from "./LprsTable.vue?vue&type=template&id=adcaa35e&scoped=true"
import script from "./LprsTable.vue?vue&type=script&lang=js"
export * from "./LprsTable.vue?vue&type=script&lang=js"
import style0 from "./LprsTable.vue?vue&type=style&index=0&id=adcaa35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcaa35e",
  null
  
)

export default component.exports